import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedin,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.jpg" alt="Robolog Automation" className="footer-logo-image" />
              <span>Robolog Automation</span>
            </Link>
            <p className="footer-tagline">
              Industrial automation solutions for the modern factory.
            </p>
            <a href="https://linkedin.com" className="social-link" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>

          {/* Quick Links */}
          <div className="footer-links-group">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-links-group">
            <h4>Solutions</h4>
            <ul>
              <li>PCB Test Jigs</li>
              <li>Robotic Cells</li>
              <li>Industrial IoT</li>
              <li>PLC Panels</li>
              <li>Monitoring Software</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h4>Contact</h4>
            <div className="contact-items">
              <a href="tel:+919487924487" className="footer-contact-item">
                <FaPhone />
                <span>+91 9487924487</span>
              </a>
              <a href="mailto:robologautomation@gmail.com" className="footer-contact-item">
                <FaEnvelope />
                <span>robologautomation@gmail.com</span>
              </a>
              <div className="footer-contact-item">
                <FaMapMarkerAlt />
                <span>Dharmapuri, Tamil Nadu</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; 2024 Robolog Automation. All rights reserved.</p>
          <Link to="/contact" className="footer-cta">
            Start a Project <FaArrowRight />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
